// src/pages/providers/2_dashboard/utils/substringFilterOption.js

/**
 * react-select filterOption: keep an option when the user's typed text is a
 * case-insensitive substring of the option label or value.
 *
 * Used by the patient-setup wizard so long lists (Contract Type, the full
 * ICB Subcontract Type list) can be narrowed by typing "Devon", "RTC", etc.
 * rather than scrolling. react-select's default matcher is similar; this
 * helper makes the rule explicit and independently testable.
 *
 * @param {{ label?: string, value?: string }} option react-select filter option
 * @param {string} input The current search string
 * @returns {boolean} True when the option should stay visible
 */
export default function substringFilterOption(option, input) {
  if (typeof input !== 'string' || !input.trim()) return true;
  const needle = input.trim().toLowerCase();
  const label = String(option?.label ?? '').toLowerCase();
  const value = String(option?.value ?? '').toLowerCase();
  return label.includes(needle) || value.includes(needle);
}
